import { motion } from "framer-motion";
import { images } from "../assets/images";
import { BackgroundMedia } from "./BackgroundMedia";

export function HeroSection() {
  return (
    <section id="home" className="relative h-screen w-full flex items-end justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <BackgroundMedia
          videoSrc={images.hero}
          imageSrc={images.heroImage}
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-black/20" />
      </div>

      {/* Content - 置于底部 */}
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.5, delay: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="relative z-10 pb-24 px-8 md:px-12 max-w-7xl w-full"
      >
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1.3 }}
          className="inline-block"
        >
          <h1 className="text-white tracking-wide leading-tight">
            <div className="flex items-center gap-2 md:gap-4">
              <span className="text-xl md:text-3xl lg:text-4xl">每</span>
              
              {/* 倒计时样式 00:10 */}
              <span className="inline-flex items-center gap-1">
                {/* 0 */}
                <span className="inline-flex items-center justify-center bg-gradient-to-b from-slate-800 to-slate-900 rounded-md md:rounded-xl px-2 md:px-4 lg:px-5 py-2 md:py-4 lg:py-5 shadow-2xl border border-slate-700 relative min-w-[2rem] md:min-w-[3.5rem] lg:min-w-[5rem]">
                  <span className="absolute inset-0 bg-gradient-to-b from-white/5 to-transparent rounded-md md:rounded-xl"></span>
                  <span className="text-4xl md:text-7xl lg:text-8xl text-white relative z-10 tabular-nums">0</span>
                </span>
                
                {/* 0 */}
                <span className="inline-flex items-center justify-center bg-gradient-to-b from-slate-800 to-slate-900 rounded-md md:rounded-xl px-2 md:px-4 lg:px-5 py-2 md:py-4 lg:py-5 shadow-2xl border border-slate-700 relative min-w-[2rem] md:min-w-[3.5rem] lg:min-w-[5rem]">
                  <span className="absolute inset-0 bg-gradient-to-b from-white/5 to-transparent rounded-md md:rounded-xl"></span>
                  <span className="text-4xl md:text-7xl lg:text-8xl text-white relative z-10 tabular-nums">0</span>
                </span>
                
                {/* 冒号 */}
                <span className="text-4xl md:text-7xl lg:text-8xl text-white px-1">:</span>
                
                {/* 1 */}
                <span className="inline-flex items-center justify-center bg-gradient-to-b from-slate-800 to-slate-900 rounded-md md:rounded-xl px-2 md:px-4 lg:px-5 py-2 md:py-4 lg:py-5 shadow-2xl border border-slate-700 relative min-w-[2rem] md:min-w-[3.5rem] lg:min-w-[5rem]">
                  <span className="absolute inset-0 bg-gradient-to-b from-white/5 to-transparent rounded-md md:rounded-xl"></span>
                  <span className="text-4xl md:text-7xl lg:text-8xl text-white relative z-10 tabular-nums">1</span>
                </span>
                
                {/* 0 */}
                <span className="inline-flex items-center justify-center bg-gradient-to-b from-slate-800 to-slate-900 rounded-md md:rounded-xl px-2 md:px-4 lg:px-5 py-2 md:py-4 lg:py-5 shadow-2xl border border-slate-700 relative min-w-[2rem] md:min-w-[3.5rem] lg:min-w-[5rem]">
                  <span className="absolute inset-0 bg-gradient-to-b from-white/5 to-transparent rounded-md md:rounded-xl"></span>
                  <span className="text-4xl md:text-7xl lg:text-8xl text-white relative z-10 tabular-nums">0</span>
                </span>
              </span>
              
              <span className="text-xl md:text-3xl lg:text-4xl">分钟</span>
            </div>
            <span className="text-xl md:text-3xl lg:text-4xl">战争让一位儿童堕入永恒的黑暗</span>
          </h1>
          {/* 下划线装饰 */}
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: "100%" }}
            transition={{ duration: 1, delay: 2, ease: "easeOut" }}
            className="h-1 bg-white mt-6"
          />
        </motion.div>
      </motion.div>
    </section>
  );
}

